import { useState, useEffect } from 'react';
import styles from './QRCode.module.scss';

export function useQrImage(url, params) {
	const [imageUrl, setImageUrl] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchImage = async () => {
			try {
				// Construct URL with query parameters
				const urlObj = new URL(url, window.location.origin);
				// Object.keys(params).forEach(key =>
				// 	urlObj.searchParams.append(key, params[key])
				// );

				const response = await fetch(urlObj);
				if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

				const blob = await response.blob();
				const objectURL = URL.createObjectURL(blob);
				setImageUrl(objectURL);
				setLoading(false);

				// Cleanup function
				return () => URL.revokeObjectURL(objectURL);
			} catch (err) {
				console.log('@@@err', err);
				setError(err);
				setLoading(false);
			}
		};

		fetchImage();
	}, [url, params]);

	return { imageUrl, loading, error };
}

export default function QRCode() {
	const [isFullScreen, setIsFullScreen] = useState(false);
	const { imageUrl, loading, error } = useQrImage('/api/member/qrcode');

	return !loading && !error ? (
		<div
			className={isFullScreen ? styles.qrcodeFull : styles.qrcodeSmall}
			onClick={() => {
				setIsFullScreen(state => !state);
			}}>
			<img
				src={imageUrl}
				alt="QRCode"
				className={!isFullScreen ? styles.blinkQrCode : ''}
			/>
			{isFullScreen ? (
				<div className={styles.clickText}>Click anywhere to close the QR Code</div>
			) : null}
		</div>
	) : null;
}
